<template>
  <div>
    <skills
      v-if="isSkills"
      ref="skills"
      :form="form.skills.data"
      :field="field"
      :field-type="fieldType"
      @editDictionary="$emit('editDictionary', $event)"
    />
    <career
      v-if="isCareer"
      ref="career"
      :form="form.career.data"
      :field="field"
      :field-type="fieldType"
      @editDictionary="$emit('editDictionary', $event)"
    />
    <personal-data
      v-if="isPersonalData"
      ref="personalData"
      :form="form.personalData.data"
      :field="field"
      :field-type="fieldType"
      @editDictionary="$emit('editDictionary', $event)"
    />
  </div>
</template>

<script>
import Skills from "./Skills";
import Career from "./Career";
import PersonalData from "./PersonalData";
import { FIELD_TYPE_SKILLS, FIELD_TYPE_CAREER, FIELD_TYPE_PERSONAL_DATA } from "@/domains/profile/constants/system-types";

export default {
  components: { Skills, Career, PersonalData },
  props: ["form", "field", "fieldType"],
  computed: {
    isSkills() {
      return this.fieldType === FIELD_TYPE_SKILLS;
    },

    isCareer() {
      return this.fieldType === FIELD_TYPE_CAREER;
    },

    isPersonalData() {
      return this.fieldType === FIELD_TYPE_PERSONAL_DATA;
    },
  },
};
</script>
